import { createSessionModule, nullOnUnauthorized } from '@nucleus-commerce/admin-kit/session';
import {
  getAdminV1Me,
  postAdminV1AuthLogout,
  type StaffProfile,
} from '@nucleus-commerce/api-client/admin';

/** Tenant admin session: /admin/v1/me with organization, role, permissions and stores. */
export const session = createSessionModule<StaffProfile>({
  fetchMe: () => nullOnUnauthorized(getAdminV1Me({ skipUnauthorizedHook: true })),
  logout: () => postAdminV1AuthLogout({}),
});

export type Me = StaffProfile;
